import apiClient from './api';

/**
 * Qualidade (C7): a presença, que é o sinal de atividade da regra de inatividade, e a taxa de resposta
 * da própria profissional.
 */

/**
 * "Estou usando o app agora". O backend grava no máximo uma vez por dia e, se o perfil estava fora da
 * busca por inatividade, devolve na hora. Quem não é profissional não grava nada.
 */
export async function registrarPresenca() {
  await apiClient.post('/profissional/me/presenca');
}

/**
 * A taxa de resposta da profissional e se o perfil está oculto: `{ respondidos, expirados, taxa,
 * taxaBaixa, taxaMinima, minimoPedidos, janelaDias, calculadoEm, ocultoPorInatividade }`, ou null para
 * quem não tem perfil profissional (204). `taxa` vem nula abaixo do mínimo de pedidos.
 */
export async function obterMinhaQualidade() {
  const resposta = await apiClient.get('/profissional/me/qualidade');
  return resposta.status === 204 ? null : resposta.data;
}
